import type { EditorPlugin } from '../../types/aha-editor';

const TranscriptCueSchemaPlugin: EditorPlugin = {
  name: 'Transcript cue schema plugin',
  schema: {
    'transcript-cue': {
      isInline: true,
    },
  },
};

export default TranscriptCueSchemaPlugin;
